export default {
  API_PRODUCTION_ENDPOINT: 'http://localhost:8080/api',
  API_ENDPOINT: 'https://petful-sam-richard.herokuapp.com/api',
  TOKEN: 'My token'
}